export const CENTER =
  'flex min-h-[60vh] flex-col items-center justify-center gap-3.5 p-[var(--pad)] text-center';
